/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycFinalObservationsDto } from '../../models/kyc-final-observations-dto';

export interface GetFinalObservations$Params {
  processId: string;
}

export function getFinalObservations(http: HttpClient, rootUrl: string, params: GetFinalObservations$Params, context?: HttpContext): Observable<StrictHttpResponse<KycFinalObservationsDto>> {
  const rb = new RequestBuilder(rootUrl, getFinalObservations.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycFinalObservationsDto>;
    })
  );
}

getFinalObservations.PATH = '/kyc/processes/{processId}/final-observations';
